<template>
  <AssignRoom></AssignRoom>
</template>
<script>
import AssignRoom from '@/views/mci/reception/AssignRoom.vue'
export default {
  components: { AssignRoom }
}
</script>
